import { HttpRequest } from '@lib/api/httpRequest';

export async function getAddressSuggestions(address: string, signal?: AbortSignal) {
    const query = new URLSearchParams({ address, limit: '5' });
    const url = `/v1/address/search?${query.toString()}`;
    const http = new HttpRequest();
    return await http.get(url, {
        signal,
        timeout: 30000,
    });
}
